import { CircleAlert } from 'lucide-react';
import React, { useMemo } from 'react';
import cn from '../../ui/primitives/cn';
import { fieldErrorClasses } from '../../ui/primitives/input';

/**
 * A field's error, in the slot its help text uses: 12/600 --error-text after a 14px
 * circle-alert (redesign iteration 1).
 *
 * The forms run react-hook-form with `criteriaMode: 'all'`, so one field can fail several
 * rules at once and `types` holds a message for each; every one is shown, one per line,
 * under a single icon. Each keeps its `form-error-message` class as a hook, and nothing
 * renders at all when there is no error, so the icon never stands on its own.
 *
 * `id` is for the control's `aria-describedby`, and `className` adds the gap under the box
 * when the error is not inside MUI's helper text, which spaces itself. A form without
 * `criteriaMode: 'all'` has no `types`, and its one `message` is shown instead.
 */
const FormFieldError = (props) => {
  const { error, id, className } = props;
  const allMessages = useMemo(() => {
    if (!error) return [];
    return error.types ? Object.values(error.types) : [error.message].filter(Boolean);
  }, [error]);
  if (!allMessages.length) return null;
  return (
    <span className={cn('field-error', fieldErrorClasses, className)} id={id}>
      <CircleAlert className="tw-flex-none tw-mt-px" size={14} aria-hidden="true" />
      <span className="tw-flex tw-flex-col">
        {allMessages.map((message, index) => (
          <span key={index} className="form-error-message">
            {message}
          </span>
        ))}
      </span>
    </span>
  );
};

export default FormFieldError;
